export const NAV_LINKS = [
  {
    label: 'House Tours',
    href: '/categories/show?category=house-tours',
    as: '/house-tours',
    sections: [
      {
        sectionName: 'By Home Type',
        sectionLinks: [
          {
            href: '/tags/show?category=house-tours&tags=apartment',
            label: 'Apartments',
            as: '/house-tours/apartment'
          },
          {
            href: '/tags/show?category=house-tours&tags=tiny-home',
            label: 'Houses',
            as: '/house-tours/house'
          },
          {
            href: '/tags/show?category=house-tours&tags=house',
            label: 'Studio Apartments',
            as: '/house-tours/studio'
          },
          {
            href: '/tags/show?category=house-tours&tags=studio',
            label: 'Tiny Homes',
            as: '/house-tours/tiny-houses'
          },
          {
            href: '/categories/show?category=house-tours',
            label: 'More',
            as: `/house-tours`
          }
        ]
      },
      {
        sectionName: 'By Location',
        sectionLinks: [
          {
            href: '/tags/show?category=house-tours&tags=new-york',
            label: 'New York City',
            as: '/house-tours/new-york'
          },
          {
            href: '/tags/show?category=house-tours&tags=los-angeles',
            label: 'Los Angeles',
            as: '/house-tours/los-angeles'
          },
          {
            href: '/tags/show?category=house-tours&tags=chicago',
            label: 'Chicago',
            as: '/house-tours/chicago'
          },
          {
            href: '/tags/show?category=house-tours&tags=london',
            label: 'London',
            as: '/house-tours/london'
          },
          {
            href: '/tags/show?category=house-tours&tags=san-francisco',
            label: 'San Francisco',
            as: '/house-tours/san-francisco'
          },
          {
            href: '/tags/show?category=house-tours',
            as: '/house-tours',
            label: 'More'
          }
        ]
      }
    ],
    recirc: [
      {
        title: 'Watch'
      }
    ]
  },
  {
    label: 'Style',
    href: '/categories/show?tags=design',
    as: '/design',
    sections: [
      {
        sectionName: 'Browse Photos',
        sectionLinks: [
          {
            href: '/image/collection?room=living-room',
            as: '/image/collection?room=living-room',
            label: 'Living Rooms'
          },
          {
            href: '/image/collection?room=bedroom',
            as: '/image/collection?room=bedroom',
            label: 'Bedrooms'
          },
          {
            href: '/image/collection?room=kitchen',
            as: '/image/collection?room=kitchen',
            label: 'Kitchens'
          },
          {
            href: '/image/collection?room=bathroom',
            as: '/image/collection?room=bathroom',
            label: 'Bathrooms'
          },
          {
            href: '/image/collection?room=patio',
            as: '/image/collection?room=patio',
            label: 'Patios'
          }
        ]
      },
      {
        sectionName: 'Style & Design',
        sectionLinks: [
          {
            href: '/tags/show?tags=decorating',
            label: 'Decorating Ideas',
            as: '/collection/decorating'
          },
          {
            href: '/tags/show?tags=trends',
            label: 'Design Trends',
            as: '/collection/trends'
          },
          {
            href: '/tags/show?tags=color',
            label: 'Color',
            as: '/collection/color'
          },
          {
            href: '/tags/show?tags=design',
            label: 'More',
            as: '/design'
          }
        ]
      },
      {
        sectionName: 'Before & After',
        sectionLinks: [
          {
            href: '/tags/show?tags=before-after,kitchen',
            label: 'Kitchens',
            as: '/collection/before-after/kitchen'
          },
          {
            href: '/tags/show?tags=before-after,bathroom',
            label: 'Bathrooms',
            as: '/collection/before-after/bathroom'
          },
          {
            href: '/tags/show?tags=before-after,living-room',
            label: 'Living Rooms',
            as: '/collection/before-after/living-room'
          },
          {
            href: '/tags/show?tags=before-after,bedroom',
            label: 'Bedrooms',
            as: '/collection/before-after/bedroom'
          },
          {
            href: '/tags/show?tags=before-after,entryway',
            label: 'Entryways',
            as: '/collection/before-after/entryway'
          },
          {
            href: '/tags/show?tags=before-after',
            label: 'More',
            as: '/collection/before-after'
          }
        ]
      }
    ],
    recirc: [
      {
        title: 'Watch'
      }
    ]
  },
  {
    label: 'How To',
    href: '/categories/show?category=projects',
    as: '/projects',
    category: 'Home Projects',
    sections: [
      {
        sectionName: "How To's",
        sectionLinks: [
          {
            href: '/tags/show?tags=hacks',
            label: 'Hacks',
            as: '/collection/hacks'
          },
          {
            href: '/tags/show?tags=painting',
            label: 'Paint',
            as: '/collection/painting'
          },
          {
            href: '/tags/show?tags=cleaning',
            label: 'Cleaning',
            as: '/collection/cleaning'
          },
          {
            href: '/tags/show?tags=diy',
            label: 'Easy DIYs',
            as: '/collection/diy'
          }
        ]
      },
      {
        sectionName: 'Home Repair &<br />Maintenance',
        sectionLinks: [
          {
            href: '/tags/show?tags=weekend-projects',
            label: 'Weekend Projects',
            as: '/collection/weekend-projects'
          },
          {
            href: '/tags/show?tags=insect-pest-solutions',
            label: 'Pest Control',
            as: '/collection/insect-pest-solutions'
          },
          {
            href: '/tags/show?tags=safety-security',
            label: 'Home Security',
            as: '/collection/safety-security'
          },
          {
            href: '/tags/show?tags=ac-heaters',
            label: 'Heating & Cooling',
            as: '/collection/ac-heaters'
          }
        ]
      },
      {
        sectionName: 'Plants and Gardening',
        sectionLinks: [
          {
            href: '/collection/plant-design',
            label: 'How to Style Houseplants'
          },
          {
            href: '/features/houseplant-guide-encyclopedia',
            label: 'Houseplant Encyclopedia'
          },
          {
            href: '/post/show?id=265241',
            label: 'Easiest Houseplants to Grow',
            as: '/easy-plants-to-grow-265241'
          },
          {
            href: '/post/show?id=238931',
            label: 'Best Indoor Trees',
            as: '/large-indoor-trees-that-make-a-bold-statement-238931'
          },
          {
            href: '/post/show?id=258836',
            label: 'How to Grow an Avocado Plant',
            as: '/how-to-grow-avocado-plants-258836'
          },
          {
            href: '/post/show?id=239893',
            label: 'How to Grow a Money Tree',
            as: '/money-tree-plants-our-best-tips-for-growing-and-care-239893'
          },
          {
            href: '/post/show?id=228575',
            label: 'Indoor Garden Ideas',
            as:
              '/15-indoor-garden-ideas-for-wannabe-gardeners-in-small-spaces-228575'
          },
          {
            href: '/post/show?id=236892',
            label: 'Growing Hydroponic Plants in Water',
            as:
              '/hydroponic-gardening-how-to-easily-grow-plants-in-water-236892'
          }
        ]
      }
    ],
    recirc: [
      {
        title: 'Watch'
      }
    ]
  },
  {
    label: 'Organize & Clean',
    href: '/categories/show?category=organizing-cleaning',
    as: '/organizing-cleaning',
    sections: [
      {
        sectionName: 'Topics',
        sectionLinks: [
          {
            href: '/tags/show?tags=disinfecting',
            label: 'Disinfecting',
            as: '/collection/disinfecting'
          },
          {
            href: '/tags/show?tags=decluttering',
            label: 'Decluttering',
            as: '/collection/decluttering'
          },
          {
            href: '/tags/show?tags=organizing,storage',
            label: 'Organizing & Storage',
            as: '/collection/organizing/storage'
          },
          {
            href: '/tags/show?tags=cleaning',
            label: 'Cleaning Tips',
            as: '/collection/cleaning'
          },
          {
            href: '/tags/show?tags=laundry',
            label: 'Laundry Tips',
            as: '/collection/laundry'
          }
        ]
      },
      {
        sectionName: 'Natural Cleaning',
        sectionLinks: [
          {
            href: '/post/show?id=108150',
            label: 'Natural Cleaner Recipes',
            as:
              '/how-to-make-your-own-bathroom-cleaners-shopping-list-recipes-108150'
          },
          {
            href: '/post/show?id=36742312',
            label: 'White Vinegar Uses',
            as: '/vinegar-cleaning-hacks-36742312'
          },
          {
            href: '/post/show?id=250575',
            label: 'Lemon Uses',
            as: '/everything-you-need-to-know-about-cleaning-with-lemons-250575'
          },
          {
            href: '/post/show?id=235579',
            label: 'Apple Cider Vinegar Uses',
            as:
              '/13-ways-to-clean-your-whole-home-with-apple-cider-vinegar-235579'
          },
          {
            href: '/post/show?id=238685',
            label: 'Tea Tree Oil Uses',
            as: '/how-to-disinfect-your-whole-home-with-tea-tree-oil-238685'
          }
        ]
      },
      {
        sectionName: 'Pest Control',
        sectionLinks: [
          {
            href: '/post/show?id=246521',
            label: 'Mosquitoes',
            as: '/our-best-mosquito-repellent-strategies-246521'
          },
          {
            href: '/post/show?id=258231',
            label: 'Drain Flies',
            as: '/how-to-get-rid-of-drain-flies-258231'
          },
          {
            href: '/post/show?id=235328',
            label: 'Roaches',
            as: '/3-non-toxic-tips-for-ridding-your-home-of-roaches-235328'
          },
          {
            href: '/post/show?id=189111',
            label: 'Ants',
            as:
              '/how-to-make-a-natural-homemade-ant-killer-apartment-therapy-tutorials-189111'
          },
          {
            href: '/post/show?id=263866',
            label: 'Mice',
            as: '/how-to-get-rid-of-mice-263866'
          }
        ]
      }
    ],
    recirc: [{ title: 'Watch' }]
  },
  {
    label: 'Living',
    href: '/life',
    sections: [
      {
        sectionName: 'Real Estate',
        sectionLinks: [
          {
            href: '/collection/moving',
            label: 'Moving'
          },
          {
            href: '/collection/home-financing',
            label: 'Home Financing'
          },
          {
            href: '/collection/resources-for-renters',
            label: 'Resources for Renters'
          },
          {
            href: '/collection/first-time-home-buyers',
            label: 'First-Time Home Buyers'
          },
          {
            href: '/collection/property-crush',
            label: 'Property Crush'
          }
        ]
      },
      {
        sectionName: 'Money',
        sectionLinks: [
          {
            href: '/collection/budget',
            label: 'Budgeting Hacks'
          },
          {
            href: '/collection/saving-investing',
            label: 'Saving & Investing'
          },
          {
            href: '/collection/budget-living',
            label: 'Budget Living'
          },
          {
            href: '/collection/career',
            label: 'Career'
          }
        ]
      },
      {
        sectionName: 'Life',
        sectionLinks: [
          {
            href: '/collection/home-for-the-holidays',
            label: 'Home for the Holidays'
          },
          {
            href: '/collection/mindful-living',
            label: 'Intentional Living'
          },
          {
            href: '/collection/parenting',
            label: 'Family'
          },
          {
            href: '/collection/pets-at-home',
            label: 'Pets'
          },
          {
            href: '/collection/wellness',
            label: 'Wellness'
          },
          {
            href: '/collection/green-living',
            label: 'Green Living'
          },
          {
            href: '/collection/entertaining-at-home',
            label: 'Entertaining'
          }
        ]
      }
    ],
    recirc: [{ title: 'Watch' }]
  },
  {
    label: 'Shop',
    href: '/categories/show?category=shop',
    as: '/shop',
    sections: [
      {
        sectionName: 'Shop by Room',
        sectionLinks: [
          {
            href: '/tags/show?tags=shop,storage',
            label: 'Storage',
            as: '/shop/storage'
          },
          {
            href: '/tags/show?tags=shop,kitchen',
            label: 'Kitchen',
            as: '/shop/kitchen'
          },
          {
            href: '/tags/show?tags=shop,bathroom',
            label: 'Bathroom',
            as: '/shop/bathroom'
          },
          {
            href: '/tags/show?tags=shop,living-room',
            label: 'Living Room',
            as: '/shop/living-room'
          },
          {
            href: '/tags/show?tags=shop,bedroom',
            label: 'Bedroom',
            as: '/shop/bedroom'
          }
        ]
      },
      {
        sectionName: 'Shop Vintage @ Bazaar',
        sectionLinks: [
          {
            href: 'https://marketplace.apartmenttherapy.com/category/Rugs',
            label: 'Rugs'
          },
          {
            href: 'https://marketplace.apartmenttherapy.com/category/Tabletop',
            label: 'Tabletop'
          },
          {
            href: 'https://marketplace.apartmenttherapy.com/category/Lighting',
            label: 'Lighting'
          },
          {
            href: 'https://marketplace.apartmenttherapy.com/category/Furniture',
            label: 'Furniture'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/category/Furniture/Storage',
            label: 'Storage'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/category/Furniture/Sofas',
            label: 'Sofas'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/category/Furniture/Tables',
            label: 'Tables'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/category/Furniture/Seating',
            label: 'Chairs'
          }
        ]
      },
      {
        sectionName: 'Shop Vintage by Style',
        sectionLinks: [
          {
            href:
              'https://marketplace.apartmenttherapy.com/search?styles=Mid%20Century%20Modern',
            label: 'Mid-century Modern'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/search?page=1&styles=Modern',
            label: 'Modern'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/search?page=1&styles=Rustic',
            label: 'Rustic'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/search?page=1&styles=Industrial',
            label: 'Industrial'
          },
          {
            href:
              'https://marketplace.apartmenttherapy.com/search?page=1&styles=Scandinavian',
            label: 'Scandinavian'
          }
        ]
      }
    ],
    recirc: [
      {
        title: 'Shopping Guides'
      },
      {
        title: 'Top Shopping Posts'
      }
    ]
  }
];

export const AMP_HAMBURGER_LINKS_1 = [
  ...NAV_LINKS,
  {
    label: 'Videos',
    href: 'https://video.apartmenttherapy.com',
    target: '_blank',
    rel: 'noreferrer'
  },
  {
    label: 'Partner Content',
    href: '/tags/show?tag=sponsored',
    as: '/collection/sponsored-post'
  }
];

export const AMP_HAMBURGER_LINKS_2 = [
  {
    label: 'Partner with Us',
    href: 'https://advertising.apartmenttherapy.com'
  },
  {
    label: 'About',
    as: '/about/about-us',
    href: '/page?path=/about/about-us'
  },
  {
    label: 'Contact',
    as: '/about/contact',
    href: '/page?path=/about/contact'
  },
  {
    label: 'Terms of Use',
    as: '/about/terms',
    href: '/page?path=/about/terms'
  },
  {
    label: 'Privacy Policy',
    as: '/about/privacy-policy',
    href: '/page?path=/about/privacy-policy'
  },
  {
    label: 'Jobs',
    href: 'https://www.apartmenttherapymedia.com/jobs/'
  },
  {
    label: 'Team',
    href: '/team'
  }
];

export const FOOTER_LINKS = [
  {
    label: 'Partner with Us',
    href: 'https://advertising.apartmenttherapy.com'
  },
  {
    label: 'About',
    as: '/about/about-us',
    href: '/page?path=/about/about-us'
  },
  {
    label: 'Contact',
    as: '/about/contact',
    href: '/page?path=/about/contact'
  },
  {
    label: 'Press',
    as: '/about/press',
    href: '/page?path=/about/press'
  },
  {
    label: 'Terms of Use',
    as: '/about/terms',
    href: '/page?path=/about/terms'
  },
  {
    label: 'Privacy Policy',
    as: '/about/privacy-policy',
    href: '/page?path=/about/privacy-policy'
  },
  {
    label: 'EU Data Subject Requests',
    href:
      'https://privacyportal-cdn.onetrust.com/dsarwebform/aca0e9e8-93f2-47a5-ba3f-00029564ca26/bf93fc0c-a870-4de6-b72d-3c28a369ffa0.html'
  },
  {
    label: 'California Do Not Sell',
    href:
      'https://privacyportal-cdn.onetrust.com/dsarwebform/aca0e9e8-93f2-47a5-ba3f-00029564ca26/940bff02-4541-4ab6-b774-90419620316e.html'
  },
  {
    label: 'Our Team',
    href: '/team'
  },
  {
    label: 'Jobs',
    href: 'https://www.apartmenttherapymedia.com/jobs/'
  },
  {
    label: 'Site map',
    href: '/sitemap'
  }
];

export const SOCIAL_LINKS = [
  {
    label: 'facebook',
    href: 'https://www.facebook.com/apartmenttherapy'
  },
  {
    label: 'pinterest',
    href: 'https://www.pinterest.com/apttherapy'
  },
  {
    label: 'instagram',
    href: 'https://www.instagram.com/apartmenttherapy'
  },
  {
    label: 'youtube',
    href: 'https://www.youtube.com/apartmenttherapy'
  },
  {
    label: 'email',
    href: '/mailing-list?source=landing_homepage'
  },
  {
    label: 'flipboard',
    href: 'https://flipboard.com/@AptTherapy'
  }
];

export const TWITTER_NAME = 'apttherapy';

export const FEATURE_LINKS = [
  {
    narrowImageUrl:
      'https://cdn.apartmenttherapy.info/image/upload/v1604598523/cs/2020/at/Greendigs%20Plants%20Vertical/20_Plants_NAV_Mobile.png',
    wideImageUrl:
      'https://cdn.apartmenttherapy.info/image/upload/v1604598523/cs/2020/at/Greendigs%20Plants%20Vertical/20_Plants_NAV_Desktop.png',
    href: '/tags/show?tag=plant-design',
    as: '/collection/plant-design'
  }
];

export const MORE_SECTIONS = [
  {
    sectionName: 'Read',
    sectionLinks: [
      ...NAV_LINKS,
      {
        label: 'Real Estate',
        href: '/categories/show?category=real-estate',
        as: 'real-estate'
      },
      {
        label: 'News',
        href: '/categories/show?category=news',
        as: 'news'
      },
      {
        label: 'Partner Content',
        href: '/tags/show?tag=sponsored',
        as: '/collection/sponsored-post'
      }
    ]
  },
  {
    sectionName: 'Company',
    sectionLinks: [
      {
        label: 'Partner with Us',
        href: 'https://advertising.apartmenttherapy.com'
      },
      {
        label: 'About',
        as: '/about/about-us',
        href: '/page?path=/about/about-us'
      },
      {
        label: 'Contact',
        as: '/about/contact',
        href: '/page?path=/about/contact'
      },
      {
        label: 'Terms of Use',
        as: '/about/terms',
        href: '/page?path=/about/terms'
      },
      {
        label: 'Privacy Policy',
        as: '/about/privacy-policy',
        href: '/page?path=/about/privacy-policy'
      },
      {
        label: 'Jobs',
        href: 'https://www.apartmenttherapymedia.com/jobs/'
      },
      {
        label: 'Team',
        href: '/team'
      }
    ]
  },
  {
    sectionName: 'Watch',
    sectionLinks: [
      {
        label: 'House Tours',
        href:
          'https://video.apartmenttherapy.com/m/dNAoLuHp/marikas-gathering-friendly-loft-house-tour?list=1xVOF6uQ'
      },
      {
        label: 'How-To',
        href:
          'https://video.apartmenttherapy.com/m/p5xIMM4E/how-to-grow-your-own-avocado-plant?list=PUDc6r8Q'
      },
      {
        label: 'Marie Kondo',
        href:
          'https://video.apartmenttherapy.com/m/okMNIgOr/pack-a-suitcase-with-marie-kondo?list=nScgzcjH'
      },
      {
        label: 'Plant Doctor',
        href:
          'https://video.apartmenttherapy.com/m/jCOXEaYH/your-ultimate-fiddle-leaf-fig-guide-the-plant-doctor?list=O6HaUZTk'
      },
      {
        label: 'Taryn Cleans It All',
        href:
          'https://video.apartmenttherapy.com/m/wynGyzXD/how-to-declutter-your-closet?list=2rCdl2Ck'
      },
      {
        label: 'The New Homesmiths',
        href:
          'https://video.apartmenttherapy.com/m/svCPgZcy/the-new-homesmiths-we-live-in-a-shipping-container?list=qNS9ehmg'
      },
      {
        label: '$32 Design Challenge',
        href:
          'https://video.apartmenttherapy.com/m/iESMqEfh/a-stylish-and-functional-entryway-transformation?list=lzsAQrFw'
      },
      {
        label: 'Adorable Animation',
        href:
          'https://video.apartmenttherapy.com/m/d04OdG50/9-stylish-house-plants-and-how-to-not-immediately-kill-them?list=2MSvStVX'
      },
      {
        label: 'More',
        href: 'https://video.apartmenttherapy.com/'
      }
    ]
  }
];

export const ACCOUNT_LINKS = [
  {
    label: 'Saved Stories',
    href: '/account/saved-stories'
  },
  {
    label: 'Vision Boards',
    href: '/account/vision-boards'
  },
  {
    label: 'Wish Lists',
    href: '/account/wish-lists'
  }
];
